import base from './base';
import { permissionComputeds, authorOrPermissionMethods } from './base';

export default {
	mixins: [base],
	computed: permissionComputeds('CHANGE_COMPANY'),
};
